module.exports = __webpack_public_path__ + "img/Informatica.f15072df.png";